import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { TabData } from '@/components/blocks/Tabs';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Stack } from '@mui/material';
import { tabsDescriptionMobileSX } from './styles/tabsDescription';
import { useLocalization } from '@/data/Localization';

export const TabsMobile: React.FC<{ tabs: TabData[], scrollToSection: (id: string) => void }> = ({ tabs, scrollToSection }) => {
    const [expanded, setExpanded] = React.useState(-1);
    const handleChange = (panel: number) => (_event: any, isExpanded: boolean) => setExpanded(isExpanded ? panel : -1);
    const localization = useLocalization('productDetail');
    return (
        <Stack sx={tabsDescriptionMobileSX}>
            {tabs?.map((tab, i) =>
                <Accordion
                    onChange={handleChange(i)}
                    expanded={expanded === i}
                    elevation={0}
                    key={`pdp-tab-accordion${tab.title}`}
                >
                    <AccordionSummary
                        expandIcon={expanded === i ? <RemoveIcon color="primary" /> : <AddIcon color="primary" />}
                        aria-controls={`panel${i}-content`}
                        aria-label="Toon inhoud"
                        id={`panel${i}-header`}
                    >
                        <Typography component="span" sx={{fontFamily:expanded === i ? 'mikado-black' : 'inherit'}}>{tab.title}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {tab.content}
                    </AccordionDetails>
                </Accordion>
            )}
            <Stack 
                sx={{borderBottom:'1px solid', pt:2}} 
                direction="row" 
                alignItems="center" 
                justifyContent="space-between" 
                width="100%"
                onClick={()=>scrollToSection(`BVRR_Container`)}
            >
                <Typography fontWeight="bold">{localization.Reviews.t()}</Typography>
                <AddIcon color="primary" />
            </Stack>
        </Stack>
    );
}
